import React, { Component } from 'react'
import { Redirect } from "react-router-dom"
import axios from 'axios'
import ReCAPTCHA from "react-google-recaptcha"
import CreditCard from "./CreditCard"
import Login from './Login'

import './home/css/test.css'
import "bootstrap/dist/css/bootstrap.min.css"

const recaptchaRef = React.createRef()

class Enter extends Component {
  constructor() {
    super()
    this.state = {
      name: "",
      email: "",
      password: "",
      birthday: "",
      phone: "",
      rulesAndTerms: false,
      confirmPassword: "",
      street: "",
      state: "",
      city: "",
      zip: "",
      human: false,
      complete: false,
      isActive: false
    }
    this.changeName = this.changeName.bind(this)
    this.changeEmail = this.changeEmail.bind(this)
    this.changePhone = this.changePhone.bind(this)
    this.changeRulesAndTerms = this.changeRulesAndTerms.bind(this)
    this.changePassword = this.changePassword.bind(this)
    this.changeConfirmPassword = this.changeConfirmPassword.bind(this)
    this.changeBirthday = this.changeBirthday.bind(this)
    this.changeStreet = this.changeStreet.bind(this)
    this.changeState = this.changeState.bind(this)
    this.changeCity = this.changeCity.bind(this)
    this.changeZip = this.changeZip.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
    this.addActiveClass = this.addActiveClass.bind(this);
  }
  changeName(event) {
    this.setState({
      name: event.target.value
    })
  }
  changePhone(event) {
    this.setState({
      phone: event.target.value
    })
  }
  changeRulesAndTerms(event) {
    this.setState({
      rulesAndTerms: event.target.checked
    })
    console.log(this.state.rulesAndTerms)
  }
  changeBirthday(event) {
    this.setState({
      birthday: event.target.value
    })
    console.log(this.state.birthday)
  }
  changeEmail(event) {
    this.setState({
      email: event.target.value
    })
  }
  changePassword(event) {
    this.setState({
      password: event.target.value
    })
  }
  changeConfirmPassword(event) {
    this.setState({
      confirmPassword: event.target.value
    })
  }
  changeStreet(event) {
    this.setState({
      street: event.target.value
    })
    console.log(this.state.street)
  }
  changeState(event) {
    this.setState({
      state: event.target.value
    })
  }
  changeCity(event) {
    this.setState({
      city: event.target.value
    })
  }
  changeZip(event) {
    this.setState({
      zip: event.target.value
    })
  }

  onSubmit(event) {
    event.preventDefault()
    const { password, confirmPassword, rulesAndTerms } = this.state;
    if (password !== confirmPassword) {
      alert("Password don't match");
    }
    if (rulesAndTerms === false) {
      alert("Please agree to our Rules and Terms & Conditions");
    }
    else
      if (this.state.human === true) {
        const registered = {
          name: this.state.name,
          email: this.state.email,
          password: this.state.password,
          birthday: this.state.birthday,
          phone: this.state.phone,
          street: this.state.street,
          state: this.state.state,
          city: this.state.city,
          zip: this.state.zip
        }
        console.log(registered)
        axios.post('http://localhost:4000/app/sign-up', registered)
          .then((response) => {
            console.log("RESPONSE", response)
            if (response.data.value === 0) {
              this.setState({ complete: true })
              alert("Thank you for signing up")
            }
            else if (response.data.value === 1) {
              alert("That email is already registered.")
            }
            else {
              alert("Something went wrong - please send me an email at logan@seatstir.com")
            }
          })
      }
      else {
        alert("Please prove you're not a robot")
      }
  }
  onChange(value) {
    const recaptchaValue = recaptchaRef.current.getValue();
    if (value === recaptchaValue) {
      this.setState({
        human: true
      })
    }
  }
  addActiveClass() {
    const currentState = this.state.isActive;
    this.setState({ isActive: !currentState });
    console.log(this.state)
  };

  render() {
    if (this.state.complete) {
      return <Redirect to={{ pathname: "/" }} />
    }
    return (
      <div>
        <div id="container" className={this.state.isActive ? "enter-container right-panel-active" : "enter-container"}>
          <div className="enter-form-container enter-sign-up-container">
            <form
              className="enter-form"
              data-toggle="validator"
              data-focus="false"
              onSubmit={this.onSubmit}
            >
              <h1 className="enter-createHeader">Create Account</h1>
              {/* <div className="social-container">
                <a className="enter-a" href="#" className="social"><i className="fab fa-facebook-f"></i></a>
                <a className="enter-a" href="#" className="social"><i className="fab fa-google-plus-g"></i></a>
                <a className="enter-a" href="#" className="social"><i className="fab fa-linkedin-in"></i></a>
              </div> */}
              <div className="ccWrapper">
                < a href="/memberships" className="enter-button"><span>Membersips Tiers</span></a>
              </div>
              {/* <span className="enter-span">Or register below</span> */}
              <div className="inputGrid">
                <div className="inputDiv">
                  <span className="enter-span">Name</span>
                  <input className="enter-input" type="text" placeholder="Satoshi" onChange={this.changeName} value={this.state.name} required />
                </div>
                <div className="inputDiv">
                  <span className="enter-span">Email</span>
                  <input className="enter-input" type="email" placeholder="satoshi@gmail.com" onChange={this.changeEmail} value={this.state.email} required />
                </div>
                <div className="inputDiv">
                  <span className="enter-span">Password</span>
                  <input className="enter-input" type="password" placeholder="happyseats3" onChange={this.changePassword} value={this.state.password} required />
                </div>
                <div className="inputDiv">
                  <span className="enter-span">Confirm password</span>
                  <input className="enter-input" type="password" placeholder="happyseats3" onChange={this.changeConfirmPassword} value={this.state.confirmPassword} required />
                </div>
                <div className="inputDiv">
                  <span className="enter-span">Birthday (Must be 18+)</span>
                  <input className="enter-input" type="date" onChange={this.changeBirthday} value={this.state.changeBirthday} required />
                </div>
                <div className="inputDiv">
                  <span className="enter-span">Phone</span>
                  <input className="enter-input" type="phone" placeholder="702-555-8721" onChange={this.changePhone} value={this.state.Phone} required />
                </div>
                {/* <div className="inputDiv">
                  <span className="enter-span">Address</span>
                  <input className="enter-input" type="text" placeholder="2122 Las Vegas Blvd." onChange={this.changeStreet} value={this.state.changeStreet} required />
                </div>
                <div className="inputDiv">
                  <span className="enter-span">State</span>
                  <input className="enter-input" type="text" placeholder="Nevada" onChange={this.changeState} value={this.state.changeState} required />
                </div>
                <div className="inputDiv">
                  <span className="enter-span">City</span>
                  <input className="enter-input" type="text" placeholder="Las Vegas" onChange={this.changeCity} value={this.state.changeCity} required />
                </div>
                <div className="inputDiv">
                  <span className="enter-span">ZIP</span>
                  <input className="enter-input" type="text" placeholder="89108" onChange={this.changeZip} value={this.state.changeZip} required />
                </div> */}
              </div>
              <div className="form-group checkbox white iAgreeSignUp">
                <input type="checkbox" required onChange={this.changeRulesAndTerms} />I agree with Seatstir's <a className="linkGreen" href="privacy-policy.html">Privacy Policy</a> and <a className="linkGreen" href="terms-conditions.html">Terms & Conditions</a>
              </div>
              <div className="ccWrapper">
                < CreditCard />
              </div>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={this.onChange}
              />
              <button className="signUpSubmit enter-button">Sign Up</button>
            </form>
          </div>
          {/* <div className="enter-form-container enter-sign-in-container">
            <form className="enter-form" action="#">
              <h1>Member Login</h1>
              <div className="social-container">
                <a className="enter-a" href="#" className="social"><i className="fab fa-facebook-f"></i></a>
                <a className="enter-a" href="#" className="social"><i className="fab fa-google-plus-g"></i></a>
                <a className="enter-a" href="#" className="social"><i className="fab fa-linkedin-in"></i></a>
              </div>
              <span>Or with your account</span>
              <input className="loginInput enter-input" type="email" placeholder="Email" />
              <input className="loginInput enter-input" type="password" placeholder="Password" />
              <a className="enter-a" href="#">Forgot your password?</a>
              <button className="enter-button">Sign In</button>
            </form>
          </div> */}
          <Login />
          <div className="enter-overlay-container">
            <div className="enter-overlay">
              <div className="overlay-panel overlay-left">
                <h1 className="enter-wantToJoin">Welcome back!</h1>
                <p className="enter-p">Pease login with to your account</p>
                <button className="ghost enter-button" id="signIn" onClick={this.addActiveClass}>Sign In</button>
              </div>
              <div className="overlay-panel overlay-right">
                <h1 className="enter-wantToJoin">Want to join?</h1>
                <p className="enter-p">Signing up is easy - and filling seats is even easier</p>
                <button className="ghost enter-button" id="signUp" onClick={this.addActiveClass}>Sign Up</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Enter